import { render, staticRenderFns } from "./view_trip.vue?vue&type=template&id=51ba6868&scoped=true&"
import script from "./view_trip.vue?vue&type=script&lang=js&"
export * from "./view_trip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51ba6868",
  null
  
)

export default component.exports